import { ClinicoSignupCard } from './ClinicoSignupCard';
import { ClinicoIntegratedManagement } from './ClinicoIntegratedManagement';
import { ClinicoDigitalManagement } from './ClinicoDigitalManagement';

export default function ClinicoDetails() {
    return (
        <div className="mt-[86px] mainContainer">
            <div className="pb-[50px]">
                <h2 className="lg:text-[38px] sm:text-[32px] text-[28px] font-bold text-primary-text">
                    نظام إدارة العيادات
                </h2>
                <span className="w-full h-[1px] bg-[#BFD1D3] mt-[32px] block mb-3"></span>
                <div>
                    <h6 className="md:text-[24px] text-[20px] font-semibold text-primary-text my-[24px]">الوصف</h6>
                    <p className="text-primary-text font-medium my-6 sm:text-[20px] text-[15px]">
                        هو نظام متكامل لإدارة العيادات الطبية يهدف متابعة الاستقبال وقائمة الانتظار بشكل منظم. يوفر لوحة
                        للطبيب لتسجيل التشخيص والروشتة وطلبات التحاليل يساعد النظام على تقليل الأخطاء الإدارية، تسريع
                        إجراءات العمل، وتحسين تجربة المريض داخل العيادة، مع توفير تقارير وإحصائيات دقيقة تدعم اتخاذ
                        القرار وتطوير الأداء
                    </p>
                </div>
            </div>
            <div className="flex flex-col gap-10">
                <ClinicoIntegratedManagement
                    icon="doctorAmico"
                    title="إدارة متكاملة للعيادات"
                    description="نقدم نظامًا متكاملاً لإدارة العيادات والمراكز الطبية يعتمد على تنظيم المواعيد، إدارةالحجوزات، وأتمتة الطابور، بهدف تحسين كفاءة التشغيل وتقديم تجربة سلسة للمرضى."
                />

                <ClinicoDigitalManagement
                    title="إدارة رقمية للكشوفات الطبية"
                    description="يوفّر نظام Clinco حلولًا ذكية لإدارة الكشوفات الطبية والملفات الرقمية بشكل آمن ومنظم، مما يساعد على تسريع الإجراءات وتقليل الأخطاء التشغيلية."
                />

                <ClinicoIntegratedManagement
                    icon="investmentData"
                    title="إدارة ماليات العيادة"
                    description="يوفّر Clinco نظامًا متكاملًا لإدارة ماليات العيادة يضمن تنظيم جميع العمليات المالية بدقة وشفافية يتابع تدفقات العياده المالية من كشوفات وإعادة واستشارة."
                />
            </div>

            <ClinicoSignupCard />
        </div>
    );
}
